import {
	FormControl,
	FormHelperText,
	Grid,
	Paper,
	styled,
	TextField,
} from "@mui/material";
import { isValidEmail } from "helpers/authValidation";
import { UPDATE_CHILD_RELATION } from "messages";
import { StyledButton } from "components/StyledButton";
import { Link } from "react-router-dom";
import { getPath, routes } from "routes";

const PREFIX = "UpdateChildPageForm";

const classes = {
	container: `${PREFIX}-container`,
	form: `${PREFIX}-form`,
	baseButton: `${PREFIX}-baseButton`,
	textField: `${PREFIX}-textField`,
	inputLabel: `${PREFIX}-inputLabel`,
};

const Root = styled("form")(({ theme }) => ({
	[`& .${classes.container}`]: {
		flexGrow: 1,
		justifyContent: "flex-start",
		padding: theme.spacing(2),
	},

	[`&.${classes.form}`]: {
		flexGrow: 1,
		"& .MuiTextField-root": {
			margin: theme.spacing(1),
		},
	},

	[`& .${classes.baseButton}`]: {
		padding: "10px 25px",
		float: "left",
		margin: "0 0 0 20px",
	},

	[`& .${classes.textField}`]: {
		paddingBottom: "1em",
	},

	[`& .${classes.inputLabel}`]: {
		"&": {
			backgroundColor: theme.palette.background.paper,
		},
	},
}));

export interface UpdateChildPageFormProps {
	userIdParam?: string;
	childEmail: string;
	setChildEmail: (childEmail: string) => void;
	onSubmit: (event: React.FormEvent) => void;
}

export const UpdateChildPageForm = ({
	userIdParam,
	childEmail,
	setChildEmail,
	onSubmit,
}: UpdateChildPageFormProps): JSX.Element => {
	return (
		<Root className={classes.form} onSubmit={onSubmit}>
			<Paper>
				<Grid
					container
					justifyContent="flex-start"
					direction="column"
					className={classes.container}
				>
					<FormHelperText>{UPDATE_CHILD_RELATION}</FormHelperText>
					<br />
					<FormControl variant="filled" className={classes.textField}>
						<TextField
							label="Email Address"
							variant="outlined"
							value={childEmail}
							error={!isValidEmail(childEmail) && childEmail.length > 0}
							onChange={(e) => setChildEmail(e.target.value)}
							fullWidth
							data-testid="new-child-email"
						/>
					</FormControl>
					<Grid container justifyContent="flex-end" alignItems="center">
						<Grid item>
							<StyledButton
								variant="contained"
								className={classes.baseButton}
								component={Link}
								to={
									userIdParam
										? getPath(routes._.people._.userProfile, {
												userId: userIdParam,
										  })
										: routes._.people._.me.path
								}
								data-testid="cancel-update-child"
							>
								Cancel
							</StyledButton>
						</Grid>
						<Grid item>
							<StyledButton
								variant="contained"
								color="primary"
								className={classes.baseButton}
								type="submit"
								data-testid="submit-update-child"
							>
								Update Child Relation
							</StyledButton>
						</Grid>
					</Grid>
				</Grid>
			</Paper>
		</Root>
	);
};
